import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import LoginForm from "../components/LoginForm/LoginForm"
import Footer from "../components/Footer/Footer"
import PageHeader from '../components/PageHeader/PageHeader'
import Alert from '../components/Alert/Alert'
function Login() {
  return (
    <>
<Navbar/>
{/* <PageHeader title={'Login'}/> */}
<LoginForm/>
<Footer/>
    </>
  )
}

export default Login